import { useLmsDestinationsFromQuery } from './useDestinationsFromQuery';

export const useLmsDestinationFromQuery = (): string | null => useLmsDestinationsFromQuery().at(-1) ?? null;
